import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Input, Form, Container, Row, Col, ModalFooter, ModalHeader, ModalBody, Modal } from "reactstrap";
import { api_url } from "../globalFunction/global_string";
import Swal from 'sweetalert2';
import '../TotalCss.css'
import '../FetchData.css';
import DataTable from 'react-data-table-component';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { da } from "date-fns/locale";

const NYCUUserSet = () => {
    const [file, setFile] = useState();
    const [fileKey, setFileKey] = useState(Date.now());
    const [NUCUdata, setNYCUData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false); //人員資料
    const [isNUCUDomainModalOpen, setNUCUDomainModalOpen] = useState(false); //網域modal
    const [isNUCUTYPEModalOpen, setNUCUTYPEModalOpen] = useState(false); //權限modal
    const [selectedItem, setSelectedItem] = useState(null);
    const [netNameOptions, setNetNameOptions] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [formData, setFormData] = useState({
        user_type: '',
        local_net_id: '',
        local_unit_id: '',
        userId: '',
        username: '',
        phoneExtension: '',
        email: '',
        serviceUnit: '',
        serviceOffice: '',
        nycuStatus: '',
        nycuType: '',
        domain: ''
    });
    const [selectedLocalNetName, setSelectedLocalNetName] = useState(''); // 選中的區網名稱的初始狀態
    const [originalLocalNetNameOptions, setOriginalLocalNetNameOptions] = useState([]); // 原始區網名稱選項
    const [allUnitNameOptions, setAllUnitNameOptions] = useState([]);
    const [unitNameOptions, setUnitNameOptions] = useState([]);
    const handleFileChange = (e) => {
        let selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    //NYCU檔案上傳資料
    const handleSubmit = (e) => {
        e.preventDefault();
        if (file) {
            const formData = new FormData();
            formData.append('formFile', file)
            fetch(api_url + '/api/Async/nycuExcelFile', {
                method: 'POST',
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.statusCode === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: '成功',
                            text: '檔案上傳成功！',
                        });
                        setFileKey(Date.now());
                        fetchData();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: '失敗',
                            text: `${data.detail}`,
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching options:', error);
                });
        } else {
            Swal.fire({
                icon: 'error',
                title: '錯誤',
                text: '請選擇一個檔案進行上傳！',
            });
        }
    };

    //使用者類型轉換中文
    const getUserTypeText = (userType) => {
        switch (userType) {
            case "S":
                return "超級管理員";
            case "M":
                return "區網管理員";
            case "N":
                return "單位使用者";
            default:
                return "無權限訪客";
        }
    };


    const fetchData = async () => {
        const formData = new FormData();
        formData.append('user_id', localStorage.getItem('login_user_id'));
        fetch(api_url + '/api/Async/GetNYCUListData', {
            method: 'POST',
            headers: { "Authorization": localStorage.getItem('accessToken') },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                if (result.statusCode === 200) {
                    if (result.statusCode === 200) {
                        if (result.row && Array.isArray(result.row)) {
                            const aggregatedData = result.row.reduce((acc, item) => { // 使用 result.row
                                if (acc[item.id]) {
                                    acc[item.id].domain += `, ${item.domain}`; // 累加 domain
                                } else {
                                    acc[item.id] = { ...item, domain: item.domain }; // 新增唯一 id 的數據
                                }
                                return acc;
                            }, {});

                            const finalData = Object.values(aggregatedData);
                            setNYCUData(finalData); // 設置狀態
                        }
                    }
                } else {
                    console.error('更新失敗:', result);
                }
            })
            .catch(error => {
                console.log('Error fetching JSON:', error);
            });
    }

    //取得區網資訊
    const GetNetNameOptions = async () => {
        fetch(api_url + '/api/Async/GetUserOptions', {
            method: 'POST',
            headers: { "Authorization": localStorage.getItem('accessToken') },
        })
            .then(response => response.json())
            .then(data => {
                setNetNameOptions(data.row);
                setOriginalLocalNetNameOptions(data.row); // 設置原始區網名稱選項
            })
            .catch(error => {
                console.error('Error fetching options:', error);
            });
    };


    //取得單位資訊
    const GetUnitNameOptions = async () => {
        fetch(api_url + '/api/Async/GetUnitNameOptions', {
            method: 'POST',
            headers: { "Authorization": localStorage.getItem('accessToken') },
        })
            .then(response => response.json())
            .then(data => {
                setAllUnitNameOptions(data.row);

            })
            .catch(error => {
                console.error('Error fetching unit name options:', error);
            });
    }


    //編輯按鈕
    const NYCUEditClick = (item) => {
        setSelectedItem(item); // 設置選中的項目
        setIsModalOpen(true); // 打開模態視窗
    };
    //編輯網域資料
    const NYCUEditDomainClick = (item) => {
        setSelectedItem(item); // 設置選中的項目
        setNUCUDomainModalOpen(true); // 打開模態視窗
    }
    //編輯權限資料
    const NYCUTypeEditClick = (item) => {
        setSelectedItem(item); // 設置選中的項目
        // 設置初始的表單數據
        setFormData({
            user_type: item.user_type,
            local_net_id: item.local_net_id,
            local_unit_id: item.local_unit_id
        });
        const newLocalNetNameOptions = filterLocalNetNameOptions(item.user_type);

        setNetNameOptions(newLocalNetNameOptions);
        // 根據 local_net_id 過濾單位名稱選項
        filterAndSetUnitOptions(item.local_net_id, item.user_type);
        setNUCUTYPEModalOpen(true); // 打開模態視窗
    };

    //關閉NUCY使用者資料MOdal
    const closeNYCUeditModal = () => {
        setIsModalOpen(false); // 關閉模態視窗
    };
    //關閉NUCY使用者網域資料MOdal
    const closeNUCUDomaiModal = () => {
        setNUCUDomainModalOpen(false); // 關閉模態視窗
    };
    //關閉NUCY使用者權限資料MOdal
    const closeNUCUTYPEModal = () => {
        setNUCUTYPEModalOpen(false); // 關閉模態視窗
    };
    //修改資料使用
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [id]: value
        }));
    };

    //判斷使用者權限帶出區網資料再帶出單位資料
    // 更改 user_type 時的處理
    const handleUserTypeChange = e => {
        const newUserType = e.target.value;
        // console.log(newUserType)
        setFormData(prevFormData => ({
            ...prevFormData,
            user_type: newUserType,
            local_net_id: '',
            local_unit_id: ''
        }));

        const newLocalNetNameOptions = filterLocalNetNameOptions(newUserType);
        setNetNameOptions(newLocalNetNameOptions);

    };



    //判斷使用者權限帶出區網資料
    const filterLocalNetNameOptions = (userType) => {
        let options = [...originalLocalNetNameOptions];
        switch (userType) {
            case "G":
                options = [];
                break;
            case "N":
            case "M":
                options = options.filter(option => option.item1 !== 'SU');
                break;
            case "S":
                options = options.filter(option => option.item1 === 'SU');
                break;
            default:
                options = [...netNameOptions];
        }
        return options;
    };

    //判斷使用者權限帶出區網資料再帶出單位資料(下拉選單的時候判斷)
    // 更改 local_net_id 時的處理
    const handleLocalNetNameChange = (e) => {
        const selectedLocalNetNameCode = e.target.value;
        console.log(selectedLocalNetNameCode)
        // 更新formData中的local_net_id
        setFormData(prevFormData => ({
            ...prevFormData,
            local_net_id: selectedLocalNetNameCode
        }));

        // 直接使用formData中的user_type，這裡假設它已經被設置
        const currentUserType = formData.user_type;

        // 調用filterAndSetUnitOptions來根據選擇的local_net_id和當前的userType過濾單位名稱選項
        filterAndSetUnitOptions(selectedLocalNetNameCode, currentUserType);


        // // 更新單位名稱選項
        // setUnitNameOptions(filteredOptions);

        // // 如果有過濾出來的選項，則將第一個選項設為選中的單位名稱，否則清空
        // const newSelectedLocalUnitName = filteredOptions.length > 0 ? filteredOptions[0].item2 : '';
        // setFormData(prevFormData => ({
        //     ...prevFormData,
        //     local_unit_id: newSelectedLocalUnitName
        // }));
    };


    const filterAndSetUnitOptions = (localNetId, userType) => {
        if (!localNetId) {
            setUnitNameOptions([]);
            return;
        }
        // 根據 localNetId 過濾單位名稱選項
        let filteredOptions = allUnitNameOptions.filter(item => item.item1 === localNetId);


        switch (userType) {
            case 'N':
                filteredOptions = filteredOptions.filter(item => item.item2 !== '00000');
                break;
            case 'M':
            case 'S':
                filteredOptions = filteredOptions.filter(item => item.item2 === '00000');
                break;
            default:
                filteredOptions = [];
        }
        setUnitNameOptions(filteredOptions);
    };
    //儲存使用者資料
    const saveNYCUChanges = () => {
        const submitData = new FormData();
        submitData.append('user_id', formData.userId);
        submitData.append('phoneExtension', formData.phoneExtension);
        submitData.append('user_name', formData.username);
        submitData.append('serviceUnit', formData.serviceUnit);
        submitData.append('serviceOffice', formData.serviceOffice);
        submitData.append('NYCUStatus', formData.nycuStatus);
        submitData.append('NYCUType', formData.nycuType);
        submitData.append('e_mail', formData.email);
        fetch(api_url + '/api/Async/PutNYCUUser', {
            method: 'POST',
            headers: {
                "Authorization": localStorage.getItem('accessToken'),
            },
            body: submitData,
        })
            .then(response => response.json())
            .then(result => {

                if (result.result.statusCode === 200) {
                    fetchData();
                    closeNYCUeditModal();
                    Swal.fire({
                        title: '成功!',
                        text: '修改成功',
                        icon: 'success',
                        confirmButtonText: '確定'
                    });
                } else {
                    console.error('更新失敗:', result);
                }
            })
            .catch(error => {
                console.log('Error fetching JSON:', error);
            });
    }
    //刪除使用者資料
    const NYCUDeleteClick = (id) => {
        Swal.fire({
            title: '確定要刪除這個帳號嗎？',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('user_id', id)
                fetch(api_url + '/api/Async/DeleteAsync0101', {
                    method: 'POST',
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                })
                    .then(response => response.json())
                    .then(result => {

                        if (result.statusCode === 200) {
                            fetchData();
                        } else {
                            console.error('更新失敗:', result);
                        }
                    })
                    .catch(error => {
                        console.log('Error fetching JSON:', error);
                    });
            }
        })
    }
    //儲存使用者網域資料
    const saveNYCUdomainChanges = () => {
        const Domain = JSON.stringify(formData.domain);
        const submitData = new FormData();
        submitData.append('currentUserId', localStorage.getItem('login_user_id'));
        submitData.append('user_name', formData.username);
        submitData.append('user_id', formData.userId);
        submitData.append('domain', Domain);
        fetch(api_url + '/api/Async/PutUserDomain', {
            method: 'POST',
            headers: {
                "Authorization": localStorage.getItem('accessToken'),
            },
            body: submitData,
        })
            .then(response => response.json()) // 提取 JSON 数据
            .then(result => {
                if (result.statusCode === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: '【修改成功】',
                        text: '恭喜'
                    });
                    fetchData();
                    closeNUCUDomaiModal();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: `${result.detail}`,
                        text: '更新失敗'
                    });
                    console.error('更新失敗:', result);
                }
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: '【出錯了】',
                    text: '無法完成請求'
                });
                console.log('Error fetching JSON:', error);
            });
    };
    //儲存使用者權限
    const saveNUCUTYPEChanges = () => {
        const loggedInUserId = localStorage.getItem('login_user_id');
        const userId = formData.userId;

        const selectedUserType = formData.user_type;
        const selectednetId = formData.local_net_id;
        const selectedUnitId = formData.local_unit_id;
        if (loggedInUserId === userId) {
            Swal.fire({
                icon: 'error',
                title: '【您不能修改當前登入的帳號權限。請用另一個帳號登入以進行修改】',
                text: 'sorry'
            });
            return;
        }
        const submitData = new FormData();
        submitData.append('currentUserId', loggedInUserId);
        submitData.append('user_type', selectedUserType);
        submitData.append('Local_net_id', selectednetId);
        submitData.append('user_id', userId);
        submitData.append('Local_unit_id', selectedUnitId);
        fetch(api_url + '/api/Async/PutLocalNetIdAsync0101', {
            method: 'POST',
            headers: {
                "Authorization": localStorage.getItem('accessToken'),
            },
            body: submitData,
        })
            .then(response => response.json())
            .then(result => {
                if (result.result.statusCode === 200) {
                    fetchData();
                    closeNUCUTYPEModal();
                } else {
                    console.error('更新失敗:', result);
                }
            })
            .catch(error => {
                console.log('Error fetching JSON:', error);
            });
    };
    useEffect(() => {

        fetchData();
        GetNetNameOptions();
        GetUnitNameOptions();
        if (selectedItem) {

            setFormData({
                user_type: selectedItem.user_type,
                local_net_id: selectedItem.local_net_id,
                local_unit_id: selectedItem.local_unit_id,
                userId: selectedItem.user_id,
                username: selectedItem.user_name,
                phoneExtension: selectedItem.phoneExtension,
                email: selectedItem.e_mail,
                serviceUnit: selectedItem.serviceUnit,
                serviceOffice: selectedItem.serviceOffice,
                nycuStatus: selectedItem.nycuStatus,
                nycuType: selectedItem.nycuType,
                domain: selectedItem.domain
            });
        }
    }, [selectedItem]);


    useEffect(() => {
        handleLocalNetNameChange({ target: { value: formData.local_net_id } });
    }, []);
    //搜尋使用方法
    const handleFilterChange = (e) => {
        setFilterText(e.target.value);
    };
    //搜尋使用方法
    const filteredData = NUCUdata.filter((row) => {

        const searchString = `${row.domain}${row.local_net_name} ${row.local_unit_name}${getUserTypeText(row.user_type)}${row.user_id} ${row.user_name}`.toLowerCase();
        return searchString.includes(filterText.toLowerCase());
    });

    const columns = [
        {

            name: '操作',
            cell: row => (
                <div>
                    <Button color="primary" className="mx-2" onClick={() => NYCUTypeEditClick(row)}>
                        編輯權限
                    </Button>
                    <Button color="info" className="mx-2" onClick={() => NYCUEditClick(row)}>
                        編輯個人資料
                    </Button>
                    <Button color="success" className="mx-2" onClick={() => NYCUEditDomainClick(row)}>
                        編輯網域資料
                    </Button>
                    <Button color="danger" className="mx-2" onClick={() => NYCUDeleteClick(row.user_id)}>
                        刪除
                    </Button>
                </div>
            ),

        },
        {
            name: '使用者權限',
            selector: row => getUserTypeText(row.user_type),
            sortable: true,
        },
        {

            name: '使用者區網名稱',
            selector: row => row.local_net_name,
            sortable: true,
        },
        {
            name: '使用者單位名稱',
            selector: row => row.local_unit_name,
            sortable: true,
        },
        {
            name: '使用者名稱',
            selector: row => row.user_name,
            sortable: true,
        },
        {
            name: '使用者帳號',
            selector: row => row.user_id,
            sortable: true,
        },
        {
            name: '使用者網域資料',
            selector: row => row.domain,
            sortable: true,
            cell: row => (
                <div style={{
                    minWidth: '200px', // 根據需要調整最小寬度
                    maxWidth: '100%', // 使得單元格寬度不超過其容器的寬度
                    whiteSpace: 'normal', // 允許文本換行
                    overflow: 'hidden', // 隱藏超出單元格範圍的文本
                    textOverflow: 'ellipsis', // 用省略號表示被截斷的文本
                    border: 'none', // 無邊框
                    padding: '10px', // 內邊距
                    backgroundColor: 'transparent', // 透明背景
                    lineHeight: '1.6', // 行高
                }}>
                    {row.domain}
                </div>
            ),
        }
    ];

    return (
        <Container>
            <Form onSubmit={handleSubmit} className="upload-form">
                <FormGroup>
                    <Row>
                        <Col md={8} className="d-flex align-items-center">
                            <Label for="NYCUFile"  >請匯入EXCEL檔案</Label>
                            <Input
                                type="file"
                                name="file"
                                id="NYCUFile"
                                onChange={handleFileChange}
                                accept=".xlsx, .xls"
                                key={fileKey}
                            />
                        </Col>
                        <Col md={4} className="upload-button">
                            <Button type="submit" color="primary" className="mt-2">上傳</Button>
                        </Col>
                    </Row>
                </FormGroup>

            </Form>
            {/* <table className="table">
                <thead>
                    <tr>
                        <th className='nancy_table_width20'>
                            <div className="nancy-table-topC">操作</div></th>
                        <th className='nancy_table_width15'>
                            <div className="nancy-table-topC">使用者權限</div></th>
                        <th className='nancy_table_width15'>
                            <div className="nancy-table-top">使用者區網名稱</div></th>
                        <th className='nancy_table_width15'>
                            <div className="nancy-table-top">使用者單位名稱</div></th>
                        <th className='nancy_table_width10'>
                            <div className="nancy-table-topC">使用者名稱</div></th>
                        <th className='nancy_table_width10'>
                            <div className="nancy-table-topC">使用者帳號</div></th>
                        <th className='nancy_table_width60'>
                            <div className="nancy-table-top">使用者網域資料</div></th>
                    </tr>
                </thead>
                <tbody>
                    {NUCUdata && NUCUdata.map((item, index) => (
                        <tr key={index}>
                            <td>
                                <Button color="primary" size="sm" onClick={() => NYCUTypeEditClick(item)}>
                                    編輯權限
                                </Button>
                                {' '}
                                <Button color="info" size="sm" onClick={() => NYCUEditClick(item)}>
                                    編輯個人資料
                                </Button>
                                {' '}
                                <Button color="success" size="sm" onClick={() => NYCUEditDomainClick(item)}>
                                    編輯網域資料
                                </Button>
                                {' '}
                                <Button color="danger" size="sm" onClick={() => NYCUDeleteClick(item.user_id)}>
                                    刪除
                                </Button>
                            </td>
                            <td>{getUserTypeText(item.user_type)}</td>
                            <td>{item.local_net_name}</td>
                            <td>{item.local_unit_name}</td>
                            <td>{item.user_name}</td>
                            <td>{item.user_id}</td>
                            <td>{item.domain}</td>
                        </tr>
                    ))}
                </tbody>
            </table> */}
            <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 20, 50, 100, filteredData.length]}
                customStyles={{
                    headRow: {
                        style: { background: 'transparent' },
                    },
                    headCells: {
                        style: { fontSize: '14px', fontWeight: 'bold' },
                    },
                }}
                highlightOnHover
                responsive
                onRowClicked={(row) => console.log(row)}
                subHeader
                subHeaderComponent={
                    <div className="row  justify-content-end">
                        <div className="col-md-4 input-group">
                            <div className="input-group-prepend bg-info">
                                <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                                    <FontAwesomeIcon icon={faSearch} color="white" />
                                </span>
                            </div>
                            <Input
                                type="text"
                                placeholder="篩選-請輸入文字..."
                                value={filterText}
                                onChange={handleFilterChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                }
            />

            <Modal isOpen={isModalOpen} toggle={closeNYCUeditModal}>
                <ModalHeader toggle={closeNYCUeditModal}>修改資料</ModalHeader>
                <ModalBody>
                    {selectedItem && (
                        <Form>
                            <FormGroup>
                                <Label for="userId">使用者帳號</Label>
                                <Input type="text" id="userId" value={selectedItem.user_id} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label for="username">使用者名稱</Label>
                                <Input type="text"
                                    id="username"
                                    value={formData.username}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="phoneExtension">分機</Label>
                                <Input type="text"
                                    id="phoneExtension"
                                    value={formData.phoneExtension}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="email">信箱</Label>
                                <Input type="text"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="serviceUnit">服務單位/在學單位</Label>
                                <Input type="text" id="serviceUnit" value={formData.serviceUnit}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="serviceOffice">服務處室/院系</Label>
                                <Input type="text" id="serviceOffice" value={formData.serviceOffice}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="nycuStatus">在職/在學狀態</Label>
                                <Input type="text" id="nycuStatus" value={formData.nycuStatus}
                                    onChange={handleInputChange} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="NYCUType">使用者類型</Label>
                                <Input type="text" id="nycuType" value={formData.nycuType}
                                    onChange={handleInputChange} />
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={saveNYCUChanges}>儲存</Button>
                    <Button color="secondary" onClick={closeNYCUeditModal}>取消</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isNUCUDomainModalOpen} toggle={closeNUCUDomaiModal}>
                <ModalHeader toggle={closeNUCUDomaiModal}>網域資料</ModalHeader>
                <ModalBody>
                    {selectedItem && (
                        <Form>
                            <FormGroup>
                                <Label for="userId">使用者帳號</Label>
                                <Input type="text" id="userId" value={formData.userId} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label for="username">使用者名稱</Label>
                                <Input type="text"
                                    id="username"
                                    value={formData.username}
                                    readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label for="domain">使用者網域</Label>
                                <Input
                                    type="textarea"
                                    id="domain"
                                    onChange={handleInputChange}
                                    value={formData.domain}
                                    rows="10"
                                    cols="10"
                                />
                            </FormGroup>

                        </Form>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={saveNYCUdomainChanges}>儲存</Button>
                    <Button color="secondary" onClick={closeNUCUDomaiModal}>取消</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isNUCUTYPEModalOpen} toggle={closeNUCUTYPEModal}>
                <ModalHeader toggle={closeNUCUTYPEModal}>權限設定</ModalHeader>
                <ModalBody>
                    {selectedItem && (
                        <Form>
                            <FormGroup>
                                <Label for="user_type">使用者權限</Label>
                                <Input type="select" id="user_type" value={formData.user_type} onChange={handleUserTypeChange}>
                                    <option value="S">超級管理員</option>
                                    <option value="M">區網管理員</option>
                                    <option value="N">單位使用者</option>
                                    <option value="G">無權限訪客</option>
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="local_net_id">使用者區網名稱</Label>
                                <Input type="select" id="local_net_id" value={formData.local_net_id} onChange={handleLocalNetNameChange}>
                                    <option value="">選擇區網名稱</option>
                                    {netNameOptions.map(option => (
                                        <option key={option.item1} value={option.item1}>
                                            {option.item2}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="local_unit_id">使用者單位名稱</Label>
                                <Input type="select" id="local_unit_id" value={formData.local_unit_id} onChange={handleInputChange}>
                                    <option value="">選擇單位名稱</option>
                                    {unitNameOptions.map(option => (
                                        <option key={option.item2} value={option.item2}>
                                            {option.item3}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={saveNUCUTYPEChanges}>儲存</Button>
                    <Button color="secondary" onClick={closeNUCUTYPEModal}>取消</Button>
                </ModalFooter>
            </Modal>
        </Container>


    );
};

export default NYCUUserSet;
